import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { promoInViewDataLayerEvent } from "utils/analytics";

import styles from "./EventStreamCap.css";

export default class EventStreamCap extends React.Component {
  componentDidMount() {
    promoInViewDataLayerEvent("stream_cap_event_promo", this.props.event);
  }

  render() {
    const {
      event: { title, link, content },
    } = this.props;
    return (
      <div className={classNames(styles.root, "gtm-stream-cap-event-promo")}>
        <h4 className={styles.content}>
          <span>{title}</span>
          <a className={styles.link} href={link}>
            {content}
          </a>
        </h4>
      </div>
    );
  }
}

EventStreamCap.propTypes = {
  event: PropTypes.shape({
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }).isRequired,
};
